module.exports = __webpack_public_path__ + "img/introduce-icon5.35f4e37c.png";